import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { LoadingStatusWrapper } from 'sharedComponents';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import TrendCommentsModalCommentForm from './TrendCommentsModalCommentForm';

const TrendCommentsModalContent = ({ loadingStatus, showError, errorData, onRetry, onReportIssue, formProps }) => {
    return (
        <Container fluid className='add-edit-comment-container gx-0'>
            <LoadingStatusWrapper
                useCustomAnchor
                transparent
                loadingStatus={[loadingStatus]}
            >
                {showError ?
                    <ErrorView
                        errorCode={errorData.errorCode}
                        onRetry={onRetry}
                        onReportIssue={onReportIssue}
                    /> :
                    <TrendCommentsModalCommentForm {...formProps} />
                }
            </LoadingStatusWrapper>
        </Container>
    );
};

TrendCommentsModalContent.propTypes = {
    loadingStatus: PropTypes.string,
    showError: PropTypes.bool,
    errorData: PropTypes.object,
    onRetry: PropTypes.func,
    onReportIssue: PropTypes.func,
    formProps: PropTypes.object
};

export default TrendCommentsModalContent;
